import { Skeleton } from '@/shared/ui/skeleton';

const NAV_ITEM_COUNT = 8;

const AppShellSkeleton = () => {
	return (
		<div className='flex h-full min-h-screen relative'>
			{/* Sidebar */}
			<div className='fixed top-0 left-0 z-40 bg-light flex flex-col gap-8 min-h-screen h-screen border border-tertiary px-4 py-5 sidebar-expanded-width'>
				<Skeleton
					width={120}
					height={28}
					borderRadius={6}
				/>
				<div className='flex flex-col gap-2 flex-1'>
					{Array.from({ length: NAV_ITEM_COUNT }).map((_, i) => (
						<Skeleton
							key={i}
							height={40}
							borderRadius={8}
						/>
					))}
				</div>
				<Skeleton
					height={40}
					borderRadius={8}
				/>
			</div>

			{/* Main content */}
			<div className='w-full flex flex-col margin-sidebar-expanded space-y-8'>
				{/* Topbar */}
				<div className='page-max-width w-full page-gutter'>
					<div className='flex justify-end items-center gap-4 py-6'>
						<Skeleton
							width={44}
							height={44}
							borderRadius={8}
						/>
						<Skeleton
							width={180}
							height={44}
							borderRadius={12}
						/>
					</div>
				</div>

				{/* Generic page content */}
				<div className='flex flex-col gap-6 page-gutter page-max-width w-full'>
					<Skeleton
						height={32}
						width='30%'
						borderRadius={8}
					/>
					<Skeleton
						height={20}
						width='60%'
						borderRadius={6}
					/>
					<div className='flex flex-col gap-4 mt-4'>
						<Skeleton
							height={56}
							borderRadius={8}
						/>
						<Skeleton
							height={56}
							borderRadius={8}
						/>
						<Skeleton
							height={56}
							borderRadius={8}
						/>
						<Skeleton
							height={56}
							borderRadius={8}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AppShellSkeleton;
